var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"pdfComponent"}},[_c('h4',{staticClass:"titleClass"},[_vm._v(_vm._s(_vm.title))]),_c('ejs-pdfviewer',{attrs:{"id":"pdfViewer","serviceUrl":_vm.serviceUrl,"documentPath":_vm.documentPath}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }